/* SIDHM MOBILE-FIRST V3 — lightweight responsive enhancements. */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  if (!body) return;

  body.classList.add('ag-mobile-ready');
  if (document.querySelector('.ag-mobile-buy, .ag-sticky-product-buy')) {
    body.classList.add('ag-has-mobile-buy');
  }

  function setViewportVars() {
    root.style.setProperty('--ag-vh', (window.innerHeight * 0.01) + 'px');
    var header = document.querySelector('.ag-header');
    if (header) root.style.setProperty('--ag-header-height', header.offsetHeight + 'px');
  }

  var resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(setViewportVars, 100);
  }

  setViewportVars();
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize, { passive: true });

  /* Native swipe support for the homepage hero without changing autoplay. */
  var hero = document.querySelector('[data-ag-hero]');
  if (hero) {
    var startX = 0;
    var startY = 0;
    var dragging = false;
    var suppressHeroLink = false;

    hero.addEventListener('pointerdown', function (event) {
      var interactive = event.target.closest('a,button');
      if (event.pointerType === 'mouse' || (interactive && !interactive.matches('[data-ag-hero-link]'))) return;
      startX = event.clientX;
      startY = event.clientY;
      dragging = true;
      suppressHeroLink = false;
    }, { passive: true });

    hero.addEventListener('pointerup', function (event) {
      if (!dragging) return;
      dragging = false;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
      suppressHeroLink = true;
      var control = hero.querySelector(dx < 0 ? '[data-ag-hero-next]' : '[data-ag-hero-prev]');
      if (control) control.click();
    }, { passive: true });

    hero.addEventListener('pointercancel', function () { dragging = false; }, { passive: true });

    hero.querySelectorAll('[data-ag-hero-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!suppressHeroLink) return;
        event.preventDefault();
        suppressHeroLink = false;
      });
    });
  }

  /* Keep horizontal product/category rails keyboard-scrollable. */
  document.querySelectorAll('.ag-track,.ag-review-track,.ag-purpose-chips,.ag-category-list').forEach(function (rail) {
    if (!rail.hasAttribute('tabindex')) rail.setAttribute('tabindex', '0');
    rail.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      rail.scrollBy({ left: event.key === 'ArrowRight' ? Math.min(rail.clientWidth * 0.8, 320) : -Math.min(rail.clientWidth * 0.8, 320), behavior: 'smooth' });
    });
  });

  /* Images loaded from the Shopify editor should never keep a stale ratio. */
  document.querySelectorAll('img[loading="lazy"]').forEach(function (image) {
    image.addEventListener('load', function () { image.classList.add('is-loaded'); }, { once: true });
    if (image.complete && image.naturalWidth) image.classList.add('is-loaded');
  });

  /* Shopify-native cart updates with accessible minus/plus controls. */
  function initCartSteppers(scope) {
    var searchRoot = scope || document;
    var forms = [];
    if (searchRoot.matches && searchRoot.matches('[data-ag-cart-form]')) forms.push(searchRoot);
    if (searchRoot.querySelectorAll) {
      searchRoot.querySelectorAll('[data-ag-cart-form]').forEach(function (form) { forms.push(form); });
    }

    forms.forEach(function (form) {
      if (form.dataset.agCartStepperReady === 'true') return;
      form.dataset.agCartStepperReady = 'true';

      var updateButton = form.querySelector('[data-ag-cart-update]');
      var updateTimer = 0;

      function normalize(input) {
        var value = Math.floor(Number(input.value));
        if (!Number.isFinite(value) || value < 1) value = 1;
        input.value = String(value);
        return value;
      }

      function syncRow(input) {
        var row = input.closest('[data-ag-cart-item]');
        var minus = row && row.querySelector('[data-ag-cart-quantity-minus]');
        var value = Number(input.value);
        var atMinimum = !Number.isFinite(value) || value <= 1;
        if (minus) {
          minus.disabled = atMinimum;
          minus.setAttribute('aria-disabled', String(atMinimum));
        }
      }

      function queueCartUpdate() {
        window.clearTimeout(updateTimer);
        form.classList.add('ag-cart-form-is-updating');
        form.setAttribute('aria-busy', 'true');
        updateTimer = window.setTimeout(function () {
          if (updateButton && typeof form.requestSubmit === 'function') {
            form.requestSubmit(updateButton);
          } else if (updateButton) {
            updateButton.click();
          } else {
            form.submit();
          }
        }, 320);
      }

      form.querySelectorAll('[data-ag-cart-quantity]').forEach(function (input) {
        var row = input.closest('[data-ag-cart-item]');
        var minus = row && row.querySelector('[data-ag-cart-quantity-minus]');
        var plus = row && row.querySelector('[data-ag-cart-quantity-plus]');

        normalize(input);
        syncRow(input);

        if (minus) minus.addEventListener('click', function () {
          var current = normalize(input);
          if (current <= 1) {
            syncRow(input);
            return;
          }
          input.value = String(current - 1);
          syncRow(input);
          queueCartUpdate();
        });

        if (plus) plus.addEventListener('click', function () {
          input.value = String(normalize(input) + 1);
          syncRow(input);
          queueCartUpdate();
        });

        input.addEventListener('input', function () {
          if (input.value !== '' && Number(input.value) < 1) input.value = '1';
          syncRow(input);
        });

        input.addEventListener('change', function () {
          normalize(input);
          syncRow(input);
          queueCartUpdate();
        });
      });

      form.addEventListener('submit', function () {
        form.querySelectorAll('[data-ag-cart-quantity]').forEach(function (input) {
          normalize(input);
          syncRow(input);
        });
      });
    });
  }

  /* Match the cart's minimum-one behavior on the main product quantity control. */
  function initProductQuantityGuards(scope) {
    var searchRoot = scope || document;
    if (!searchRoot.querySelectorAll) return;

    searchRoot.querySelectorAll('.ag-product-form [data-ag-quantity]').forEach(function (input) {
      if (input.dataset.agQuantityGuardReady === 'true') return;
      input.dataset.agQuantityGuardReady = 'true';

      var quantity = input.closest('.ag-quantity');
      var minus = quantity && quantity.querySelector('[data-ag-quantity-minus]');

      function normalize() {
        var value = Math.floor(Number(input.value));
        if (!Number.isFinite(value) || value < 1) value = 1;
        input.value = String(value);
        if (minus) {
          minus.disabled = value <= 1;
          minus.setAttribute('aria-disabled', String(value <= 1));
        }
      }

      normalize();
      input.addEventListener('input', normalize);
      quantity && quantity.addEventListener('click', function () { window.setTimeout(normalize, 0); });
    });
  }

  /* Mobile footer groups behave as accessible, independent accordions. */
  function initFooterAccordions(scope) {
    var searchRoot = scope || document;
    if (!searchRoot.querySelectorAll) return;

    var groups = [];
    if (searchRoot.matches && searchRoot.matches('.ag-footer-accordion')) groups.push(searchRoot);
    searchRoot.querySelectorAll('.ag-footer-accordion').forEach(function (group) { groups.push(group); });

    groups.forEach(function (group) {
      if (group.dataset.agFooterAccordionReady === 'true') return;
      var toggle = group.querySelector('.ag-footer-accordion__toggle');
      if (!toggle) return;

      group.dataset.agFooterAccordionReady = 'true';
      var mobileQuery = window.matchMedia('(max-width: 760px)');

      function setOpen(open) {
        group.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      }

      setOpen(false);
      toggle.addEventListener('click', function () {
        if (!mobileQuery.matches) return;
        setOpen(!group.classList.contains('is-open'));
      });

      function resetForBreakpoint() { setOpen(false); }
      if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', resetForBreakpoint);
      else if (typeof mobileQuery.addListener === 'function') mobileQuery.addListener(resetForBreakpoint);
    });
  }

  initCartSteppers(document);
  initProductQuantityGuards(document);
  initFooterAccordions(document);
  document.addEventListener('shopify:section:load', function (event) {
    initCartSteppers(event.target);
    initProductQuantityGuards(event.target);
    initFooterAccordions(event.target);
  });
})();
